import { Directive, HostListener, Inject, Input, Renderer2 } from '@angular/core';
import html2canvas from 'html2canvas';
import { DOCUMENT } from '@angular/common'

@Directive({
  selector: '[appPageScreenshot]'
})
export class PageScreenshotDirective {

  @Input() fileName:string;
  constructor(@Inject(DOCUMENT) private document: Document, private ren:Renderer2) {}

  @HostListener('click') takeCurrentPageScreenShot() {
    html2canvas(this.document.body,{
      allowTaint: true,
      useCORS: true
    }).then(canvas => this.saveScreenShot(canvas,this.fileName));
  }

  saveScreenShot(canvas, fileName = 'Screenshot_Image') {
    const link = this.ren.createElement('a');
    link.download = fileName+'.png';
    canvas.toBlob(function(blob){
      link.href = URL.createObjectURL(blob);
      link.click();
    })
  }

}
